import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';

const routes: Routes = [
    {
        path: '',
        component: LoginComponent,
        children: [
            // {
            //     path: 'players',
            //     component: TeamParticipantsComponent
            // },
            // {
            //     path: 'schedule',
            //     component: TeamScheduleComponent
            // },
            // {
            //     path: 'lineup',
            //     component: TeamLineupComponent
            // },
            // {
            //     path: 'admins',
            //     component: TeamAdminsComponent
            // }
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})

export class RegistrationRoutingModule { }
